import { IconSVG } from '../types';

export const Beenhere = ({ size, style }: IconSVG) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 16 21"
      style={style}
    >
      <path
        fill="currentColor"
        d="M8 20.5c-.217 0-.425-.033-.625-.1a2.112 2.112 0 01-.575-.3l-6-4.5A1.986 1.986 0 010 14V2C0 1.45.196.98.588.587A1.926 1.926 0 012 0h12c.55 0 1.02.196 1.412.588C15.804.979 16 1.45 16 2v12a1.985 1.985 0 01-.8 1.6l-6 4.5a2.112 2.112 0 01-.575.3c-.2.067-.408.1-.625.1zm0-2l6-4.5V2H2v12l6 4.5zm-1.05-8.35l-1.4-1.4a.916.916 0 00-.7-.287 1.02 1.02 0 00-1.012 1 .93.93 0 00.287.712L6.25 12.3c.2.2.433.3.7.3.267 0 .5-.1.7-.3l4.25-4.25c.2-.2.296-.433.287-.7a1.055 1.055 0 00-.287-.7 1.02 1.02 0 00-.713-.313.93.93 0 00-.712.288L6.95 10.15z"
      />
    </svg>
  );
};
